import React, { JSX } from 'react';
import './TimerStyles.css';
import { NativeColorPicker } from './Timer.types';
import {CENTER, LEFT, TRANSPARENT, RIGHT, ZEROES} from "../../../utils/constants";

interface RibbonComponentExpiredTimerSchema {
  timerColor: string;
  backgroundColor: string;
  expiryLabel: string;
  timerAlignment: string;
  dayLabel: string;
  hourLabel: string;
  minuteLabel: string;
  secondLabel: string;
  expiryLabelColor: NativeColorPicker;
}
interface Expiry {
  content: RibbonComponentExpiredTimerSchema;
}

const RibbonComponentExpiredTimer = ({ content }: Expiry): JSX.Element => {
  return (
    <div
      className={'container'}
      style={{
        justifyContent:
          content.timerAlignment === CENTER
            ? 'center'
            : content.timerAlignment === LEFT
            ? 'left'
            : 'right',
      }}
    >
      <div
        className={'timer-section'}
        style={{
          color: content.timerColor,
          backgroundColor: content.backgroundColor,
          marginLeft:
            content.backgroundColor === TRANSPARENT &&
            content.timerAlignment === LEFT
              ? '-9px'
              : 'unset',
          marginRight:
            content.backgroundColor === TRANSPARENT &&
            content.timerAlignment === RIGHT
              ? '-24px'
              : 'unset',
        }}
      >
        <div className={'timer-element'}>
        <div className={'timer-value'}> {ZEROES} </div>
          <div className={'timer-label'}>{content.dayLabel}</div>
        </div>
        <div className={'colon'}>:</div>
        <div className={'timer-element'}>
        <div className={'timer-value'}> {ZEROES} </div>
          <div className={'timer-label'}>{content.hourLabel}</div>
        </div>
        <div className={'colon'}>:</div>
        <div className={'timer-element'}>
        <div className={'timer-value'}> {ZEROES} </div>
          <div className={'timer-label'}>{content.minuteLabel}</div>
        </div>
        <div className={'colon'}>:</div>
        <div className={'timer-element'}>
        <div className={'timer-value'}> {ZEROES}</div>
          <div className={'timer-label'}>{content.secondLabel}</div>
        </div>
      </div>
      <div className={'timer-message'} style={{ color: content.expiryLabelColor?.color }}>
        {content.expiryLabel}
      </div>
    </div>
  );
};

export default RibbonComponentExpiredTimer;
